<template>
  <div>
    <p v-if="is위험도20" class="flex justify-end items-center" style="color: #ea5455">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.79995 5.8C9.79995 5.35817 9.44178 5 8.99995 5C8.55812 5 8.19995 5.35817 8.19995 5.8V9C8.19995 9.44183 8.55812 9.8 8.99995 9.8C9.44178 9.8 9.79995 9.44183 9.79995 9V5.8ZM8.99597 11.4C8.55634 11.4 8.19995 11.7582 8.19995 12.2C8.19995 12.6418 8.55634 13 8.99597 13H9.00393C9.44356 13 9.79995 12.6418 9.79995 12.2C9.79995 11.7582 9.44356 11.4 9.00393 11.4H8.99597Z"
          fill="#EA5455"
        />
      </svg>
      위험도 20점 이상 건이 있습니다. 담당임원에게 결재 바랍니다.
    </p>

    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :fieldReadonly="board.readonly || isRevision" :board="board" :is-print="isPrint" :options="[{ type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true }]" />

    <!-- 위험성평가 구분 -->
    <maot-section title="위험성평가 구분">
      <radio-group class="col-span-4" :items="['DKRAS', 'JSA', 'DKRAS+JSA']" :row-count="3" :readonly="board.readonly || isRevision" v-model="form.위험성평가구분" />
    </maot-section>

    <!-- 위험성평가 정보 -->
    <maot-section title="위험성평가 정보">
      <div class="col-span-12 writeGridContainer m-0">
        <div>
          <div>평가일자</div>
          <div v-if="isPrint" class="print-input">{{ form.위험성평가정보.평가일자 }}</div>
          <date-selector v-else v-model="form.위험성평가정보.평가일자" :readonly="board.readonly" />
        </div>
        <div class="writeGridCol2">
          <div>공정명</div>
          <div class="flex gap-2">
            <div class="flex items-center gap-2 whitespace-no-wrap" :style="isPrint ? '' : 'width: 108px;'">
              <div v-if="isPrint" class="print-input">{{ form.위험성평가정보.팀 }}</div>
              <ml-input v-else v-model="form.위험성평가정보.팀" :readonly="form.공정명비활성화여부 || board.readonly || isRevision" />
              팀
            </div>
            <div class="flex items-center gap-2 whitespace-no-wrap" :style="isPrint ? '' : 'width: 108px;'">
              <div v-if="isPrint" class="print-input">{{ form.위험성평가정보.공장 }}</div>
              <ml-input v-else v-model="form.위험성평가정보.공장" :readonly="form.공정명비활성화여부 || board.readonly || isRevision" />
              공장
            </div>
            <div class="flex items-center gap-2 whitespace-no-wrap" :style="isPrint ? '' : 'width: 108px;'">
              <div v-if="isPrint" class="print-input">{{ form.위험성평가정보.공정 }}</div>
              <ml-input v-else v-model="form.위험성평가정보.공정" :readonly="board.readonly || isRevision" />
              공정
            </div>
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 공정분류 -->
    <maot-section title="공정분류">
      <template #right>
        <select736-button v-if="!(board.readonly || isRevision)" v-model="form.공정분류.raw" @input="onSelectProcess" />
      </template>
      <div class="col-span-12 writeGridContainer m-0">
        <div>
          <div>대분류</div>
          <div v-if="isPrint" class="print-input">{{ form.공정분류.대분류 }}</div>
          <ml-input v-else v-model="form.공정분류.대분류" readonly />
        </div>
        <div>
          <div>중분류</div>
          <div v-if="isPrint" class="print-input">{{ form.공정분류.중분류 }}</div>
          <ml-input v-else v-model="form.공정분류.중분류" readonly />
        </div>
        <div>
          <div>소분류</div>
          <div v-if="isPrint" class="print-input">{{ form.공정분류.소분류 }}</div>
          <ml-input v-else v-model="form.공정분류.소분류" readonly />
        </div>
        <div>
          <div>구분</div>
          <div>
            <radio-group flex :items="['정기', '수시']" :readonly="board.readonly || isRevision" v-model="form.공정분류.구분">
              <template #수시>
                <custom-option-selector
                  class="flex-1"
                  style="width: 108px"
                  addable-option
                  :readonly="board.readonly || isRevision"
                  :isPrint="isPrint"
                  :options="['산재', '설비안전위원회', '투자', '설비 신설', '연료변경', '기타(직접입력)']"
                  v-model="form.공정분류.구분_수시"
                />
                <ml-input v-if="form.공정분류.구분_수시 === '기타(직접입력)'" v-model="form.공정분류.구분_수시_기타" :readonly="board.readonly || isRevision" />
              </template>
            </radio-group>
          </div>
        </div>

        <div>
          <div>아차사고</div>
          <div>
            <radio-group flex :readonly="board.readonly || isRevision" :items="['Y', 'N']" v-model="form.공정분류.아차사고" />
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 아차사고 -->
    <div v-if="form.공정분류.아차사고 === 'Y'">
      <table v-if="isPrint">
        <tr>
          <th colspan="2">재해/발생유형</th>
          <th colspan="2">원인</th>
          <th colspan="2">내용</th>
        </tr>
        <tr v-for="(row, rowIndex) in form.아차사고_개정" :key="`row${rowIndex}`">
          <td>{{ row.재해발생유형_분류 }}</td>
          <td>{{ row.재해발생유형_원인 }}</td>
          <td>{{ row.원인 }}</td>
          <td>{{ row.내용 }}</td>
        </tr>
      </table>
      <table-custom
        v-else
        class="table-custom mb-6 col-span-12"
        title="아차사고"
        border-x
        :board="board"
        :controls="!(board.readonly || isRevision)"
        :is-print="isPrint"
        :tableData="[
          { id: '재해발생유형', title: '재해/발생유형', type: 'customType', readonly: board.readonly || isRevision },
          { id: '원인', title: '원인', type: 'text', readonly: board.readonly || isRevision },
          { id: '내용', title: '내용', type: 'text', readonly: board.readonly || isRevision },
        ]"
        v-model="form.아차사고_개정"
      >
        <template #customType="{ trData, id, index, input, noteIndex }">
          <div v-if="isPrint" class="flex gap-2">
            <div class="print-input">{{ form.아차사고_개정[index].재해발생유형_분류 }}</div>
            <div class="print-input">{{ form.아차사고_개정[index].재해발생유형_원인 }}</div>
          </div>
          <div v-else class="flex gap-2">
            <risk-fact-selector v-model="form.아차사고_개정[index].재해발생유형_분류" :readonly="board.readonly || isRevision" />
            <risk-fact-selector v-model="form.아차사고_개정[index].재해발생유형_원인" :분류="form.아차사고_개정[index].재해발생유형_분류" :readonly="board.readonly || isRevision" />
          </div>
        </template>
      </table-custom>
    </div>

    <!-- 작업빈도 -->
    <maot-section title="작업빈도(횟수)">
      <table class="col-span-12">
        <thead>
          <tr>
            <th>일</th>
            <th>주</th>
            <th>월</th>
            <th>분기</th>
            <th>년</th>
            <th>1회 작업시간(분)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <number-input v-model="form.작업빈도.일" :readonly="board.readonly || isRevision" />
            </td>
            <td>
              <number-input v-model="form.작업빈도.주" :readonly="board.readonly || isRevision" />
            </td>
            <td>
              <number-input v-model="form.작업빈도.월" :readonly="board.readonly || isRevision" />
            </td>
            <td>
              <number-input v-model="form.작업빈도.분기" :readonly="board.readonly || isRevision" />
            </td>
            <td>
              <number-input v-model="form.작업빈도.년" :readonly="board.readonly || isRevision" />
            </td>
            <td>
              <number-input v-model="form.작업빈도.회당작업시간" :readonly="board.readonly || isRevision" />
            </td>
          </tr>
        </tbody>
      </table>
    </maot-section>

    <!-- 담당 -->
    <maot-section title="담당">
      <div class="col-span-12 writeGridContainer">
        <div>
          <div>작성자</div>
          <div>
            <div v-if="isPrint" class="print-input">{{ form.sign.작성자.name }}</div>
            <ml-input v-else v-model="form.sign.작성자.name" :readonly="board.readonly || isRevision" />
          </div>
        </div>
      </div>
      <div class="col-span-12 writeGridContainer">
        <div>
          <div>검토자</div>
          <div>
            <div v-if="isPrint" class="print-input">{{ form.sign.검토자.name }}</div>
            <ml-input v-else v-model="form.sign.검토자.name" :readonly="board.readonly || isRevision" />
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 동일직무인원 -->
    <maot-section title="동일직무인원">
      <div class="col-span-12 writeGridContainer">
        <div>
          <div>상주반</div>
          <div class="grid items-center gap-2" style="grid-template-columns: 1fr auto">
            <number-input class="mr-2" v-model="form.동일직무인원.상주반" :readonly="board.readonly || isRevision" :min="0" />
            명
          </div>
        </div>
        <div>
          <div>교대반</div>
          <div class="grid items-center gap-2" style="grid-template-columns: 1fr auto">
            <number-input class="mr-2" v-model="form.동일직무인원.교대반" :readonly="board.readonly || isRevision" :min="0" />
            명
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 위험성평가표 -->
    <div v-if="showImprovementColumns">
      <!-- 개정 중일 경우 -->
      <maot-section v-if="isDKRAS">
        <template #title>
          위험성평가표<span v-if="form.위험성평가구분 === 'DKRAS+JSA'"> (DKRAS)</span>
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="DKRASTableData" :value="form.위험성평가표.DKRAS.data" :isRevision="isRevision" :isDKRAS="isDKRAS" :risk="form.위험성평가표.DKRAS.위험도" :important-risk="form.위험성평가표.DKRAS.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            :readonly="false"
            :controls="false"
            :is-print="isPrint"
            :tableData="DKRASTableData"
            :mobile="['발생빈도', '위험강도', '단위위험' /*, '담당자', '완료예정일'*/]"
            v-model="form.위험성평가표.DKRAS.data"
          >
            <template #customTitle>
              <div>
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.DKRAS.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div class="print-input">{{ form.위험성평가표.DKRAS.중요위험 }}</div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile, readonly }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th v-if="!(board.readonly || isRevision)" style="padding: 6px">
                    <div class="p-1 flex justify-center items-center">
                      <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                    </div>
                  </th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <!--                  <th>담당자</th>-->
                  <!--                  <th>완료일(예정일)</th>-->
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1">
                    <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                  </th>
                  <th rowspan="2">분류</th>
                  <th rowspan="2">원인</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재조치 관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="1" colspan="3">개선후 위험도</th>
                  <th rowspan="2">개선결과</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, id, index }">
              <div v-if="id === '분류'" class="">
                <risk-fact-selector v-model="form.위험성평가표.DKRAS.data[index].분류" :readonly="board.readonly || isRevision" />
              </div>
              <div v-else-if="id === '원인'" class="">
                <risk-fact-selector v-model="form.위험성평가표.DKRAS.data[index].원인" :readonly="board.readonly || isRevision" :분류="form.위험성평가표.DKRAS.data[index].분류 || ' '" />
              </div>
              <div v-else-if="id === '단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.DKRAS.data[index].발생빈도, form.위험성평가표.DKRAS.data[index].위험강도).color }">
                  {{ form.위험성평가표.DKRAS.data[index].단위위험 }}({{ form.위험성평가표.DKRAS.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.DKRAS.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
              <div v-else-if="id === '개선후_단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.DKRAS.data[index].개선후_발생빈도, form.위험성평가표.DKRAS.data[index].개선후_위험강도).color }">
                  {{ form.위험성평가표.DKRAS.data[index].개선후_단위위험 }}({{ form.위험성평가표.DKRAS.data[index].개선후_위험도 }})
                </div>
                <div v-if="form.위험성평가표.DKRAS.data[index].개선후_위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>

        <div class="col-span-12 writeGridContainer mt-2 row-gap-2">
          <div class="writeGridLineItem">
            <div>안전보호구</div>
            <div>
              <span v-if="isPrint" class="print-input">{{ form.위험성평가표.DKRAS.안전보호구 }}</span>
              <ml-input v-else v-model="form.위험성평가표.DKRAS.안전보호구" :readonly="board.readonly || isRevision" />
            </div>
          </div>
          <div class="writeGridLineItem">
            <div>정리정돈사항</div>
            <div>
              <span v-if="isPrint" class="print-input">{{ form.위험성평가표.DKRAS.정리정돈사항 }}</span>
              <ml-input v-else v-model="form.위험성평가표.DKRAS.정리정돈사항" :readonly="board.readonly || isRevision" />
            </div>
          </div>
          <div class="writeGridLineItem">
            <div>ONE POINT</div>
            <div>
              <span v-if="isPrint" class="print-input">{{ form.위험성평가표.DKRAS.ONEPOINT }}</span>
              <ml-input v-else v-model="form.위험성평가표.DKRAS.ONEPOINT" :readonly="board.readonly || isRevision" />
            </div>
          </div>
        </div>
      </maot-section>
      <maot-section v-if="isJSA">
        <template #title>
          위험성평가표<span v-if="form.위험성평가구분 === 'DKRAS+JSA'"> (JSA)</span>
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="JSATableData" :value="form.위험성평가표.JSA.data" :isRevision="isRevision" :isDKRAS="isDKRAS" :risk="form.위험성평가표.JSA.위험도" :important-risk="form.위험성평가표.JSA.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            useRowGroup
            :readonly="false"
            :controls="false"
            :is-print="isPrint"
            :tableData="JSATableData"
            :mobile="['작업단계', '발생빈도', '위험강도', '단위위험']"
            :rowGroup="['작업단계', '작업사진', '검토1차', '검토2차', '비고']"
            v-model="form.위험성평가표.JSA.data"
          >
            <template #customTitle>
              <div class="writeGridContainer" style="width: 66.66%">
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.JSA.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.JSA.중요위험 }}</div>
                  </div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th>작업단계</th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th rowspan="2">작업단계</th>
                  <th rowspan="2">작업사진</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                  <th rowspan="2">비고</th>
                  <th rowspan="1" colspan="3">개선후 위험도</th>
                  <th rowspan="2">개선결과</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, id, index }">
              <div v-if="id === '단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.JSA.data[index].발생빈도, form.위험성평가표.JSA.data[index].위험강도).color }">
                  {{ form.위험성평가표.JSA.data[index].단위위험 }}({{ form.위험성평가표.JSA.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.JSA.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
              <div v-else-if="id === '개선후_단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.JSA.data[index].개선후_발생빈도, form.위험성평가표.JSA.data[index].개선후_위험강도).color }">
                  {{ form.위험성평가표.JSA.data[index].개선후_단위위험 }}({{ form.위험성평가표.JSA.data[index].개선후_위험도 }})
                </div>
                <div v-if="form.위험성평가표.JSA.data[index].개선후_위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>
      </maot-section>
    </div>

    <div v-else>
      <maot-section v-if="isDKRAS">
        <template #title>
          위험성평가표<span v-if="form.위험성평가구분 === 'DKRAS+JSA'"> (DKRAS)</span>
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="DKRASTableData" :value="form.위험성평가표.DKRAS.data" :isRevision="isRevision" :isDKRAS="isDKRAS" :risk="form.위험성평가표.DKRAS.위험도" :important-risk="form.위험성평가표.DKRAS.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            :board="board"
            :controls="!(board.readonly || isRevision)"
            :is-print="isPrint"
            :tableData="DKRASTableData"
            :mobile="['발생빈도', '위험강도', '단위위험' /*, '담당자', '완료예정일'*/]"
            :default-size="5"
            v-model="form.위험성평가표.DKRAS.data"
          >
            <template #customTitle>
              <div class="writeGridContainer" style="width: 66.66%">
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.DKRAS.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div class="print-input">{{ form.위험성평가표.DKRAS.중요위험 }}</div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile, readonly }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th v-if="!(board.readonly || isRevision)" style="padding: 6px">
                    <div class="p-1 flex justify-center items-center">
                      <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                    </div>
                  </th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <!--                  <th>담당자</th>-->
                  <!--                  <th>완료일(예정일)</th>-->
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1">
                    <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                  </th>
                  <th rowspan="2">분류</th>
                  <th rowspan="2">원인</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재조치 관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, id, index }">
              <div v-if="id === '분류'" class="">
                <risk-fact-selector v-model="form.위험성평가표.DKRAS.data[index].분류" />
              </div>
              <div v-else-if="id === '원인'" class="">
                <risk-fact-selector v-model="form.위험성평가표.DKRAS.data[index].원인" :분류="form.위험성평가표.DKRAS.data[index].분류 || ' '" />
              </div>
              <div v-else-if="id === '단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.DKRAS.data[index].발생빈도, form.위험성평가표.DKRAS.data[index].위험강도).color }">
                  {{ form.위험성평가표.DKRAS.data[index].단위위험 }}({{ form.위험성평가표.DKRAS.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.DKRAS.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>
        <div class="col-span-12 writeGridContainer mt-2 row-gap-2">
          <div class="writeGridLineItem">
            <div>안전보호구</div>
            <div>
              <span v-if="isPrint" class="print-input">{{ form.위험성평가표.DKRAS.안전보호구 }}</span>
              <ml-input v-else v-model="form.위험성평가표.DKRAS.안전보호구" />
            </div>
          </div>
          <div class="writeGridLineItem">
            <div>정리정돈사항</div>
            <div>
              <span v-if="isPrint" class="print-input">{{ form.위험성평가표.DKRAS.정리정돈사항 }}</span>
              <ml-input v-else v-model="form.위험성평가표.DKRAS.정리정돈사항" />
            </div>
          </div>
          <div class="writeGridLineItem">
            <div>ONE POINT</div>
            <div>
              <span v-if="isPrint" class="print-input">{{ form.위험성평가표.DKRAS.ONEPOINT }}</span>
              <ml-input v-else v-model="form.위험성평가표.DKRAS.ONEPOINT" />
            </div>
          </div>
        </div>
      </maot-section>
      <maot-section v-if="isJSA">
        <template #title>
          위험성평가표<span v-if="form.위험성평가구분 === 'DKRAS+JSA'"> (JSA)</span>
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="JSATableData" :value="form.위험성평가표.JSA.data" :isRevision="isRevision" :isDKRAS="isDKRAS" :risk="form.위험성평가표.JSA.위험도" :important-risk="form.위험성평가표.JSA.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            useRowGroup
            :readonly="board.readonly || isRevision"
            :controls="!(board.readonly || isRevision)"
            :is-print="isPrint"
            :tableData="JSATableData"
            :mobile="['작업단계', '발생빈도', '위험강도', '단위위험']"
            :rowGroup="['작업단계', '작업사진', '검토1차', '검토2차', '비고']"
            :default-size="5"
            v-model="form.위험성평가표.JSA.data"
          >
            <template #customTitle>
              <div class="writeGridContainer" style="width: 66.66%">
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.JSA.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.JSA.중요위험 }}</div>
                  </div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"></th>
                  <th v-if="!(board.readonly || isRevision)" style="padding: 6px">
                    <div class="p-1 flex justify-center items-center">
                      <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                    </div>
                  </th>
                  <th>작업단계</th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"></th>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1">
                    <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                  </th>
                  <th rowspan="2">작업단계</th>
                  <th rowspan="2">작업사진</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                  <th rowspan="2">비고</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, index }">
              <div>
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.JSA.data[index].발생빈도, form.위험성평가표.JSA.data[index].위험강도).color }">
                  {{ form.위험성평가표.JSA.data[index].단위위험 }}({{ form.위험성평가표.JSA.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.JSA.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>
      </maot-section>
    </div>

    <add-row-layout
      class="mt-6 print-break-page"
      v-if="isJSA"
      title="개선내역"
      v-model="form.개선내역"
      :dataForm="{
        위험성평가: { 작업내용: '', 위험요인: '', 개선대책: '', 개선완료일: '' },
        개선사항: {
          개선전: { img: undefined, 설명: '', 빈도: '', 강도: '', 위험도: '' },
          개선후: { img: undefined, 설명: '', 빈도: '', 강도: '', 위험도: '' },
        },
      }"
    >
      <template #buttons="{ addRow, deleteRow }">
        <div v-if="!(board.readonly || isRevision)">
          <vs-button color="secondary" @click="addRow"> 개선내역 추가</vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제</vs-button>
        </div>
        <div v-else></div>
        <!-- isRevision 으로 template 속 div 를 모두 숨길경우, default 버튼이 나오므로, 그것을 방지하기 위해 빈 div 사용 -->
      </template>
      <template #default="{ data, index, checked, onCheck }">
        <p class="mb-2">- 개선내역 {{ index + 1 }}</p>
        <table class="mb-4">
          <tr>
            <th v-if="!(board.readonly || isRevision)" rowspan="6" class="cursor-pointer" @click="onCheck(index)">
              <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="checked"></vs-checkbox>
            </th>
            <th rowspan="2">위험성평가</th>
            <th rowspan="1">작업내용</th>
            <th rowspan="1">위험요인</th>
            <th rowspan="1">개선대책</th>
            <th rowspan="1">개선완료일</th>
          </tr>
          <tr>
            <td>
              <span v-if="isPrint || board.readonly" class="print-input">{{ form.개선내역[index].위험성평가.작업내용 }}</span>
              <ml-input v-else :readonly="board.readonly || isRevision" v-model="form.개선내역[index].위험성평가.작업내용" />
            </td>
            <td>
              <span v-if="isPrint || board.readonly" class="print-input">{{ form.개선내역[index].위험성평가.위험요인 }}</span>
              <ml-input v-else :readonly="board.readonly || isRevision" v-model="form.개선내역[index].위험성평가.위험요인" />
            </td>
            <td>
              <span v-if="isPrint || board.readonly" class="print-input">{{ form.개선내역[index].위험성평가.개선대책 }}</span>
              <ml-input v-else :readonly="board.readonly" v-model="form.개선내역[index].위험성평가.개선대책" />
            </td>
            <td>
              <span v-if="isPrint || board.readonly" class="print-input">{{ form.개선내역[index].위험성평가.개선완료일 }}</span>
              <date-selector v-else :readonly="board.readonly" class="w-full" v-model="form.개선내역[index].위험성평가.개선완료일" />
            </td>
          </tr>
          <tr>
            <th rowspan="4" colspan="1">개선사항</th>
            <th rowspan="1" colspan="2">개선 전</th>
            <th rowspan="1" colspan="2">개선 후</th>
          </tr>
          <tr>
            <td colspan="2">
              <FileUploaderTransparent2 :readonly="board.readonly || isRevision" v-model="form.개선내역[index].개선사항.개선전.img" style="height: 200px !important; border: 1px dashed #cdcdcd; border-radius: 6px" />
            </td>
            <td colspan="2">
              <FileUploaderTransparent2 :readonly="board.readonly" v-model="form.개선내역[index].개선사항.개선후.img" style="height: 200px !important; border: 1px dashed #cdcdcd; border-radius: 6px" />
            </td>
          </tr>
          <tr>
            <td colspan="2" v-for="개선전후 in ['개선전', '개선후']" :key="개선전후">
              <table>
                <colgroup>
                  <col />
                  <col width="83px" />
                  <col width="83px" />
                  <col width="114px" />
                </colgroup>
                <tr>
                  <td rowspan="2">
                    <span v-if="isPrint || board.readonly" class="print-textarea">{{ form.개선내역[index].개선사항[개선전후].설명 }}</span>
                    <ml-textarea v-else :readonly="board.readonly || (isRevision && 개선전후 === '개선전')" v-model="form.개선내역[index].개선사항[개선전후].설명" />
                  </td>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>위험도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                </tr>
                <tr>
                  <td>
                    <span v-if="isPrint || board.readonly" class="print-input">{{ form.개선내역[index].개선사항[개선전후].빈도 }}</span>
                    <vs-select v-else :disabled="board.readonly || (isRevision && 개선전후 === '개선전')" class="w-full" v-model="form.개선내역[index].개선사항[개선전후].빈도" autocomplete>
                      <vs-select-item v-for="item in ['5', '4', '3', '2', '1']" :key="item" :value="item" :text="item" />
                    </vs-select>
                  </td>
                  <td>
                    <span v-if="isPrint || board.readonly" class="print-input">{{ form.개선내역[index].개선사항[개선전후].강도 }}</span>
                    <vs-select v-else :disabled="board.readonly || (isRevision && 개선전후 === '개선전')" class="w-full" v-model="form.개선내역[index].개선사항[개선전후].강도" autocomplete>
                      <vs-select-item v-for="item in ['5', '4', '3', '2', '1']" :key="item" :value="item" :text="item" />
                    </vs-select>
                  </td>
                  <td>
                    <div class="print-input" :style="{ color: getRisk(form.개선내역[index].개선사항[개선전후].빈도, form.개선내역[index].개선사항[개선전후].강도).color }">
                      {{ getRisk(form.개선내역[index].개선사항[개선전후].빈도, form.개선내역[index].개선사항[개선전후].강도).name }}({{ form.개선내역[index].개선사항[개선전후].위험도 || 0 }})
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </template>
    </add-row-layout>

    <!-- 파일첨부 -->
    <file-upload-module v-model="form.fileList" :is-print="isPrint" class="mt-8" />

    <popup-risk-dksteel-frequency v-model="popup.빈도" />
    <popup-risk-dksteel-strength v-model="popup.강도" />
    <popup-risk-dksteel-decision v-model="popup.위험도" />
    <vs-popup :active.sync="popup.warning20" title="알림">
      <div>
        <table>
          <tr>
            <th style="color: #e42728">
              <div class="flex items-center justify-center">
                <feather-icon class="mr-2" icon="AlertCircleIcon" />
                <span>평가결과 20점 이상</span>
              </div>
            </th>
          </tr>
          <tr>
            <td>
              <div>※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              <div>※ 담당임원에게 결재 바랍니다.</div>
            </td>
          </tr>
        </table>
      </div>
    </vs-popup>
    <confirm-dialog ref="confirm" title="알림">
      <div class="flex items-center gap-2 font-medium">
        <span class="flex" style="width: 19px">
          <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.5 8.99749C0.5 4.03068 4.52707 0 9.5 0C14.4729 0 18.5 4.03068 18.5 8.99749C18.5 13.9643 14.4729 17.995 9.5 17.995C4.52707 17.995 0.5 13.9643 0.5 8.99749ZM9.5 1.99499C5.63637 1.99499 2.5 5.12776 2.5 8.99749C2.5 12.8672 5.63637 16 9.5 16C13.3636 16 16.5 12.8672 16.5 8.99749C16.5 5.12776 13.3636 1.99499 9.5 1.99499Z"
              fill="#E42728"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.5 3.27344C10.0523 3.27344 10.5 3.72003 10.5 4.27093V9.2584C10.5 9.8093 10.0523 10.2559 9.5 10.2559C8.94772 10.2559 8.5 9.8093 8.5 9.2584V4.27093C8.5 3.72003 8.94772 3.27344 9.5 3.27344Z"
              fill="#E42728"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.5 11.25C10.0523 11.25 10.5 11.6966 10.5 12.2475L10.5 13.245C10.5 13.7959 10.0523 14.2425 9.5 14.2425C8.94772 14.2425 8.5 13.7959 8.5 13.245L8.5 12.2475C8.5 11.6966 8.94772 11.25 9.5 11.25Z"
              fill="#E42728"
            />
          </svg>
        </span>
        <span style="color: #e42728"> 분임토의록 및 날인부, 개선내역을 첨부하셨습니까? </span>
      </div>

      <div class="my-8 flex justify-center">
        <radio-group flex v-model="popup.approval" :items="['Yes', 'No']" />
      </div>
    </confirm-dialog>

    <!-- 개정이력 팝업 -->
    <div
      v-if="revisionHistoryPopup.show"
      ref="revisionHistoryPopup"
      class="revision-history-popup"
      :style="{
        position: 'fixed',
        top: revisionHistoryPopup.position.top + 'px',
        left: revisionHistoryPopup.position.left + 'px',
      }"
    >
      <div class="revision-history-header">
        <span class="revision-history-title">개정이력</span>
        <button class="revision-history-close-button" @click="closeRevisionHistoryPopup">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <div class="revision-history-list">
        <!-- 로딩 중 -->
        <div v-if="revisionHistoryPopup.loading" class="revision-history-loading">
          <div class="loading-spinner"></div>
          <span>로딩 중...</span>
        </div>

        <!-- 데이터 없음 -->
        <div v-else-if="revisionHistoryData.length === 0" class="revision-history-empty">
          <span>개정이력이 없습니다.</span>
        </div>

        <!-- 데이터 목록 -->
        <div v-else v-for="(item, index) in revisionHistoryData" :key="index" class="revision-history-item" @click="onClickRevisionItem(item)">
          <div class="revision-history-item-content">
            <span class="revision-number">{{ item.revision }}</span>
            <span class="revision-author">{{ item.author }}</span>
            <span class="revision-date">{{ item.date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import MaotSection from "@/components/layout/MaotSection.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import Select736Button from "@/views/boards/single-page/736/Select736Button.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import NumberInput from "@/components/NumberInput.vue";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import AddRowLayout from "@/components/layout/AddRowLayout.vue";
import FileUploader from "@/components/FileUploader.vue";
import FileUploaderTransparent2 from "@/components/FileUploaderTransparent2.vue";
import PopupRiskInfoEp1 from "@/views/project/popup/PopupRiskInfoEp1.vue";
import PopupRiskInfoEp2 from "@/views/project/popup/PopupRiskInfoEp2.vue";
import PopupRiskInfoEp3 from "@/views/project/popup/PopupRiskInfoEp3.vue";
import 유해위험요인 from "@/components/selector/riskFactor/유해위험요인.js";
import RiskFactSelector from "@/components/selector/riskFactor/RiskFactSelector.vue";
import { required } from "vuelidate/lib/validators";
import PopupRiskDksteelFrequency from "@/views/project/popup/PopupRiskDksteelFrequency.vue";
import PopupRiskDksteelStrength from "@/views/project/popup/PopupRiskDksteelStrength.vue";
import PopupRiskDksteelDecision from "@/views/project/popup/PopupRiskDksteelDecision.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PrintTable from "@/views/boards/single-page/813/PrintTable.vue";
import { width } from "tailwindcss/lib/plugins";

export default {
  components: {
    PrintTable,
    ConfirmDialog,
    PopupRiskDksteelDecision,
    PopupRiskDksteelStrength,
    PopupRiskDksteelFrequency,
    RiskFactSelector,
    PopupRiskInfoEp3,
    PopupRiskInfoEp2,
    PopupRiskInfoEp1,
    FileUploaderTransparent2,
    FileUploader,
    AddRowLayout,
    NameWithSignatureRow,
    SignField,
    NumberInput,
    TableCustom,
    CustomOptionSelector,
    Select736Button,
    DateSelector,
    RadioGroup,
    MaotSection,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    parentId: [Number, String],
    isPrint: Boolean,
    board: Object,
    value: Object,
    // 816 원문보기 팝업 등에서, 개정 문서 여부와 무관하게 개선후 위험도 UI를 강제로 노출할 때 사용
    forceShowImprovement: Boolean,
  },
  validations: {
    공정분류선택: { required },
    form: {
      stdInfo: {
        field_name: { required },
      },
      위험성평가구분: { required },
      위험성평가정보: {
        평가일자: { required },
        공장: { required },
        팀: { required },
        공정: { required },
      },
      공정분류: {
        구분: { required },
        아차사고: { required },
      },
      작업빈도: {
        일: { required },
        주: { required },
        월: { required },
        분기: { required },
        년: { required },
        회당작업시간: { required },
      },
      sign: {
        작성자: { name: { required } },
        검토자: { name: { required } },
      },
      동일직무인원: {
        상주반: { required },
        교대반: { required },
      },
    },
  },
  data() {
    return {
      유해위험요인,
      popup: {
        빈도: false,
        강도: false,
        위험도: false,
        warning20: false,
        approval: "No",
      },
      revisionHistoryPopup: {
        show: false,
        position: {
          top: 0,
          left: 0,
        },
        loading: false,
      },
      revisionHistoryData: [],
      공정분류선택: false,
      DKRASTableData: [
        { id: "분류", title: "분류", type: "customType", width: "163px" },
        { id: "원인", title: "원인", type: "customType", width: "163px" },
        { id: "위험요인", title: "위험요인", type: "textarea", width: "163px" },
        { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "163px" },
        { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "단위위험", title: "단위위험", type: "customType", width: "114px" },
        { id: "감소대책", title: "감소대책", type: "textarea", width: "163px" },
        { id: "담당자", title: "담당자", type: "text", width: "163px" },
        { id: "완료예정일", title: "완료예정일", type: "date", width: "163px" },
        {
          id: "검토1차",
          title: "1차",
          type: "radio",
          radioItems: [{ value: "Y" }, { value: "N" }],
          width: "90px",
          defaultValue: "Y",
        },
        {
          id: "검토2차",
          title: "2차",
          type: "radio",
          radioItems: [{ value: "Y" }, { value: "N" }],
          width: "90px",
          defaultValue: "Y",
        },
      ],
      JSATableData: [
        { id: "작업단계", title: "작업단계", type: "textarea", width: "197px", mobileWidth: "100px" },
        { id: "작업사진", title: "작업사진", type: "img", width: "197px" },
        { id: "위험요인", title: "위험요인", type: "textarea", width: "197px" },
        { id: "현재관리상태", title: "현재관리상태", type: "textarea", width: "197px" },
        { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "단위위험", title: "단위위험", type: "customType", width: "83px" },
        { id: "감소대책", title: "감소대책", type: "textarea", width: "197px" },
        { id: "비고", title: "비고", type: "textarea", width: "197px" },
      ],
      form: {
        stdInfo: {},
        fileList: [],
        위험성평가구분: "",
        위험성평가정보: {
          평가일자: new Date().format("yyyy-MM-dd"),
          공장: "",
          팀: "",
          공정: "",
        },
        공정분류: {
          대분류: "",
          중분류: "",
          소분류: "",
          구분: "정기",
          구분_수시: "",
          구분_수시_기타: "",
          아차사고: "N",
          raw: undefined,
        },
        아차사고: [{ id: 1, 원인: "", 내용: "" }],
        아차사고_개정: [{ id: 1, 재해발생유형_분류: "설비적요인", 재해발생유형_원인: "끼임,감김", 원인: "", 내용: "" }],
        작업빈도: {
          일: "",
          주: "",
          월: "",
          분기: "",
          년: "",
          회당작업시간: "",
        },
        sign: {
          작성자: { name: "", sign: "" },
          검토자: { name: "", sign: "" },
        },
        동일직무인원: {
          상주반: "",
          교대반: "",
        },
        위험성평가표: {
          위험도: "",
          중요위험: "",
          data: [],
          DKRAS: {
            data: [],
            위험도: "",
            중요위험: "",
            안전보호구: "",
            정리정돈사항: "",
            ONEPOINT: "",
          },
          JSA: {
            data: [],
            위험도: "",
            중요위험: "",
          },
        },
        개선내역: [
          {
            위험성평가: { 작업내용: "", 위험요인: "", 개선대책: "", 개선완료일: "" },
            개선사항: {
              개선전: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
              개선후: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
            },
          },
        ],
        공정명비활성화여부: false,
      },
      is위험도20: false,
      has736Synced: false,
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    postId() {
      return this.$route.params.postId;
    },
    isDKRAS() {
      return this.form.위험성평가구분 === "DKRAS" || this.form.위험성평가구분 === "DKRAS+JSA";
    },
    isJSA() {
      return this.form.위험성평가구분 === "JSA" || this.form.위험성평가구분 === "DKRAS+JSA";
    },
    isRevision() {
      return this.parentId > 0;
    },
    // 816 원문보기 팝업일 때는 개정 여부와 무관하게 개선후 위험도 UI를 항상 노출
    showImprovementColumns() {
      return this.isRevision || this.forceShowImprovement;
    },
    isRevisionHistoryEnabled() {
      // field_id, 공장, 대분류, 중분류, 소분류 값이 모두 있어야 활성화
      const enabled = !!(this.form.stdInfo.field_id && this.form.위험성평가정보.공장 && this.form.공정분류.대분류 && this.form.공정분류.중분류 && this.form.공정분류.소분류);

      return enabled;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            if (key === "위험성평가표") {
              const val = value[key];
              // 기존 데이터(data 배열이 위험성평가표 바로 아래)를 새 구조로 마이그레이션
              if (val.data !== undefined && !val.DKRAS && !val.JSA) {
                this.migrateRiskTable(val, value.위험성평가구분);
              } else {
                this.form[key] = val;
              }
            } else {
              this.form[key] = value[key];
            }
          }

          // 개정일 경우, 현재 위험도가 일반이면, 개선후위험도의 빈도, 강도를 현재 위험도에서 가져옴
          if (this.isRevision) {
            if (key === "위험성평가표") {
              const lists = [];
              if (this.isDKRAS) lists.push(this.form.위험성평가표.DKRAS.data);
              if (this.isJSA) lists.push(this.form.위험성평가표.JSA.data);
              for (let li = 0; li < lists.length; li++) {
                const list = lists[li];
                if (!list) continue;
                for (let i = 0; i < list.length; i++) {
                  const row = list[i];
                  if (!row.발생빈도) row.발생빈도 = "1";
                  if (!row.위험강도) row.위험강도 = "1";

                  const risk = this.getRisk(row.발생빈도, row.위험강도);
                  if (risk.name === "일반") {
                    if (row.개선후_발생빈도 === undefined) row.개선후_발생빈도 = row.발생빈도;
                    if (row.개선후_위험강도 === undefined) row.개선후_위험강도 = row.위험강도;
                  }
                }
              }
            }
          }

          if (this.form.공정분류.대분류 !== "" || this.form.공정분류.중분류 !== "" || this.form.공정분류.소분류 !== "") {
            this.공정분류선택 = true;
          }
        }

        if (!this.has736Synced && this.form.공정분류.raw && this.form.공정분류.raw.id) {
          this.has736Synced = true;
          this.syncProcess736Data(this.form.공정분류.raw.id);
        }
      },
    },
    isRevision() {
      this.watchRevision();
    },
    "form.위험성평가구분"() {
      this._rebuildMergedData();
    },
    "form.위험성평가표.DKRAS.data": {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          let sum위험도 = 0;
          let is중요위험 = false;
          list = list.map((item) => {
            const 발생빈도 = Number(item.발생빈도 || 0);
            const 위험강도 = Number(item.위험강도 || 0);
            const 위험도 = 발생빈도 * 위험강도;
            sum위험도 += 위험도;
            if (발생빈도 >= 5 || 위험도 >= 10) {
              is중요위험 = true;
            }
            item.위험도 = 위험도;
            item.단위위험 = this.getRisk(발생빈도, 위험강도).name;
            if (this.isRevision) {
              const 개선후_발생빈도 = Number(item.개선후_발생빈도 || 0);
              const 개선후_위험강도 = Number(item.개선후_위험강도 || 0);
              const 개선후_위험도 = 개선후_발생빈도 * 개선후_위험강도;
              item.개선후_위험도 = 개선후_위험도;
              item.개선후_단위위험 = this.getRisk(개선후_발생빈도, 개선후_위험강도).name;
            }
            return item;
          });
          this.form.위험성평가표.DKRAS.위험도 = (sum위험도 / list.length).toFixed(1);
          this.form.위험성평가표.DKRAS.중요위험 = is중요위험 ? "Y" : "N";
          this.is위험도20 = this._computeIs위험도20();
          this._syncTopLevelRisk();
          this._rebuildMergedData();
        }
      },
    },
    "form.위험성평가표.JSA.data": {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          let sum위험도 = 0;
          let is중요위험 = false;
          list = list.map((item) => {
            const 발생빈도 = Number(item.발생빈도 || 0);
            const 위험강도 = Number(item.위험강도 || 0);
            const 위험도 = 발생빈도 * 위험강도;
            sum위험도 += 위험도;
            if (발생빈도 >= 5 || 위험도 >= 10) {
              is중요위험 = true;
            }
            item.위험도 = 위험도;
            item.단위위험 = this.getRisk(발생빈도, 위험강도).name;
            if (this.isRevision) {
              const 개선후_발생빈도 = Number(item.개선후_발생빈도 || 0);
              const 개선후_위험강도 = Number(item.개선후_위험강도 || 0);
              const 개선후_위험도 = 개선후_발생빈도 * 개선후_위험강도;
              item.개선후_위험도 = 개선후_위험도;
              item.개선후_단위위험 = this.getRisk(개선후_발생빈도, 개선후_위험강도).name;
            }
            return item;
          });
          this.form.위험성평가표.JSA.위험도 = (sum위험도 / list.length).toFixed(1);
          this.form.위험성평가표.JSA.중요위험 = is중요위험 ? "Y" : "N";
          this.is위험도20 = this._computeIs위험도20();
          this._syncTopLevelRisk();
          this._rebuildMergedData();
        }
      },
    },
    "form.개선내역": {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          list = list.map((item) => {
            for (const 개선전후 of ["개선전", "개선후"]) {
              const 위험도 = Number(item.개선사항[개선전후].빈도 || 0) * Number(item.개선사항[개선전후].강도 || 0);
              item.개선사항[개선전후].위험도 = 위험도;
            }
            return item;
          });
        } else {
          this.form.개선내역 = [
            {
              위험성평가: { 작업내용: "", 위험요인: "", 개선대책: "", 개선완료일: "" },
              개선사항: {
                개선전: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
                개선후: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
              },
            },
          ];
        }
      },
    },
    "form.공정분류.대분류": {
      deep: true,
      handler() {
        if (this.form.공정분류.대분류 !== "") {
          this.공정분류선택 = true;
        }
      },
    },
    "form.공정분류.중분류": {
      deep: true,
      handler() {
        if (this.form.공정분류.중분류 !== "") {
          this.공정분류선택 = true;
        }
      },
    },
    "form.공정분류.소분류": {
      deep: true,
      handler() {
        if (this.form.공정분류.소분류 !== "") {
          this.공정분류선택 = true;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        if (key === "위험성평가표") {
          const val = this.value[key];
          if (val.data !== undefined && !val.DKRAS && !val.JSA) {
            this.migrateRiskTable(val, this.value.위험성평가구분);
          } else {
            this.form[key] = val;
          }
        } else {
          this.form[key] = this.value[key];
        }
      }
    }

    this.watchRevision();
  },
  methods: {
    width() {
      return width;
    },

    // 구 포맷(위험성평가표 바로 아래 data 배열)을 DKRAS / JSA 구조로 옮긴다.
    // 위험성평가구분이 "DKRAS+JSA" 이거나 비어있는 문서도 데이터를 잃지 않도록 행 구성으로 판별한다.
    migrateRiskTable(val, 위험성평가구분) {
      const rows = val.data || [];
      const isJSARow = (row) => !!row && (row.작업단계 !== undefined || row.작업사진 !== undefined);

      let dkrasRows = [];
      let jsaRows = [];
      if (위험성평가구분 === "DKRAS") {
        dkrasRows = rows;
      } else if (위험성평가구분 === "JSA") {
        jsaRows = rows;
      } else {
        dkrasRows = rows.filter((row) => !isJSARow(row));
        jsaRows = rows.filter((row) => isJSARow(row));

        // 구분값이 없는 문서는 표가 아예 렌더링되지 않으므로, 판별 결과로 채워준다.
        if (!위험성평가구분) {
          if (dkrasRows.length > 0 && jsaRows.length > 0) this.form.위험성평가구분 = "DKRAS+JSA";
          else if (jsaRows.length > 0) this.form.위험성평가구분 = "JSA";
          else if (dkrasRows.length > 0) this.form.위험성평가구분 = "DKRAS";
        }
      }

      this.form.위험성평가표.DKRAS.data = dkrasRows;
      this.form.위험성평가표.DKRAS.위험도 = val.위험도 || "";
      this.form.위험성평가표.DKRAS.중요위험 = val.중요위험 || "";
      this.form.위험성평가표.DKRAS.안전보호구 = val.안전보호구 || "";
      this.form.위험성평가표.DKRAS.정리정돈사항 = val.정리정돈사항 || "";
      this.form.위험성평가표.DKRAS.ONEPOINT = val.ONEPOINT || "";

      this.form.위험성평가표.JSA.data = jsaRows;
      this.form.위험성평가표.JSA.위험도 = val.위험도 || "";
      this.form.위험성평가표.JSA.중요위험 = val.중요위험 || "";

      this.form.위험성평가표.data = rows;
      this.form.위험성평가표.위험도 = val.위험도 || "";
      this.form.위험성평가표.중요위험 = val.중요위험 || "";
    },

    watchRevision() {
      // 개정할 경우, DKRAS, JSA 테이블 데이터를 변경
      // 읽기 전용(원문보기 팝업)일 때는 개정 여부와 무관하게 개선후 위험도 컬럼을 항상 노출
      if (this.showImprovementColumns) {
        const dkrasReadonlyList = [];
        const 위험성평가표DKRAS = this.form.위험성평가표.DKRAS.data;
        for (let index = 0; index < 위험성평가표DKRAS.length; index++) {
          const row = 위험성평가표DKRAS[index];
          if (row.위험도 < 10 && row.발생빈도 < 5) {
            dkrasReadonlyList.push(index);
          }
        }

        const jsaReadonlyList = [];
        const 위험성평가표JSA = this.form.위험성평가표.JSA.data;
        for (let index = 0; index < 위험성평가표JSA.length; index++) {
          const row = 위험성평가표JSA[index];
          if (row.위험도 < 10 && row.발생빈도 < 5) {
            jsaReadonlyList.push(index);
          }
        }

        let readonlyIndexList = dkrasReadonlyList;

        this.DKRASTableData = [
          { id: "분류", title: "분류", type: "customType", width: "163px", readonly: true, readonlyIndexList },
          { id: "원인", title: "원인", type: "customType", width: "163px", readonly: true, readonlyIndexList },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "163px", readonly: true, readonlyIndexList },
          { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "163px", readonly: true, readonlyIndexList },
          {
            id: "발생빈도",
            title: "발생빈도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            readonly: true,
            readonlyIndexList,
          },
          {
            id: "위험강도",
            title: "위험강도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            readonly: true,
            readonlyIndexList,
          },
          { id: "단위위험", title: "단위위험", type: "customType", width: "114px", readonly: true, readonlyIndexList },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "163px", readonly: true, readonlyIndexList },

          {
            id: "개선후_발생빈도",
            title: "발생빈도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            readonlyIndexList,
          },
          {
            id: "개선후_위험강도",
            title: "위험강도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            readonlyIndexList,
          },
          { id: "개선후_단위위험", title: "단위위험", type: "customType", width: "114px", readonlyIndexList },
          { id: "개선결과", title: "개선결과", type: "textarea", width: "163px", readonlyIndexList },

          { id: "담당자", title: "담당자", type: "text", width: "163px", readonly: true, readonlyIndexList },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px", readonlyIndexList },
          {
            id: "검토1차",
            title: "1차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
            readonlyIndexList,
          },
          {
            id: "검토2차",
            title: "2차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
            readonlyIndexList,
          },
        ];
        // JSA 테이블은 별도의 readonly 인덱스 목록 사용
        readonlyIndexList = jsaReadonlyList;
        this.JSATableData = [
          { id: "작업단계", title: "작업단계", type: "textarea", width: "197px", mobileWidth: "100px", readonly: true, readonlyIndexList },
          { id: "작업사진", title: "작업사진", type: "img", width: "197px", readonly: true, readonlyIndexList },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "197px", readonly: true, readonlyIndexList },
          { id: "현재관리상태", title: "현재관리상태", type: "textarea", width: "197px", readonly: true, readonlyIndexList },
          {
            id: "발생빈도",
            title: "발생빈도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            mobileWidth: "50px",
            readonly: true,
            readonlyIndexList,
          },
          {
            id: "위험강도",
            title: "위험강도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            mobileWidth: "50px",
            readonly: true,
            readonlyIndexList,
          },
          { id: "단위위험", title: "단위위험", type: "customType", width: "83px", readonly: true, readonlyIndexList },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "197px", readonly: true, readonlyIndexList },

          { id: "담당자", title: "담당자", type: "text", width: "163px", readonly: true, readonlyIndexList },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px", readonlyIndexList },
          {
            id: "검토1차",
            title: "1차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
            readonlyIndexList,
          },
          {
            id: "검토2차",
            title: "2차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
            readonlyIndexList,
          },
          { id: "비고", title: "비고", type: "textarea", width: "197px", readonly: true, readonlyIndexList },

          {
            id: "개선후_발생빈도",
            title: "발생빈도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            readonlyIndexList,
          },
          {
            id: "개선후_위험강도",
            title: "위험강도",
            type: "select",
            selectData: ["5", "4", "3", "2", "1"],
            width: "83px",
            readonlyIndexList,
          },
          { id: "개선후_단위위험", title: "단위위험", type: "customType", width: "83px", readonlyIndexList },
          { id: "개선결과", title: "개선결과", type: "textarea", width: "197px", readonlyIndexList },
        ];
      } else {
        this.DKRASTableData = [
          { id: "분류", title: "분류", type: "customType", width: "163px" },
          { id: "원인", title: "원인", type: "customType", width: "163px" },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "163px" },
          { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "163px" },
          { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "단위위험", title: "단위위험", type: "customType", width: "114px" },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "163px" },

          { id: "담당자", title: "담당자", type: "text", width: "163px" },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px" },
          {
            id: "검토1차",
            title: "1차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
          },
          {
            id: "검토2차",
            title: "2차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
          },
        ];
        this.JSATableData = [
          { id: "작업단계", title: "작업단계", type: "textarea", width: "197px", mobileWidth: "100px" },
          { id: "작업사진", title: "작업사진", type: "img", width: "197px" },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "197px" },
          { id: "현재관리상태", title: "현재관리상태", type: "textarea", width: "197px" },
          { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", mobileWidth: "50px" },
          { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", mobileWidth: "50px" },
          { id: "단위위험", title: "단위위험", type: "customType", width: "83px" },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "197px" },

          { id: "담당자", title: "담당자", type: "text", width: "163px" },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px" },
          {
            id: "검토1차",
            title: "1차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
          },
          {
            id: "검토2차",
            title: "2차",
            type: "radio",
            radioItems: [{ value: "Y" }, { value: "N" }],
            width: "90px",
            defaultValue: "Y",
          },
          { id: "비고", title: "비고", type: "textarea", width: "197px" },
        ];
      }
    },

    _computeIs위험도20() {
      const dkrasData = this.form.위험성평가표.DKRAS.data;
      if (this.isDKRAS && dkrasData) {
        for (let i = 0; i < dkrasData.length; i++) {
          if (Number(dkrasData[i].위험도 || 0) >= 20) return true;
        }
      }
      const jsaData = this.form.위험성평가표.JSA.data;
      if (this.isJSA && jsaData) {
        for (let i = 0; i < jsaData.length; i++) {
          if (Number(jsaData[i].위험도 || 0) >= 20) return true;
        }
      }
      return false;
    },

    _syncTopLevelRisk() {
      const isDKRAS중요위험 = this.form.위험성평가표.DKRAS.중요위험 === "Y";
      const isJSA중요위험 = this.form.위험성평가표.JSA.중요위험 === "Y";
      this.form.위험성평가표.중요위험 = isDKRAS중요위험 || isJSA중요위험 ? "Y" : "N";
    },

    _rebuildMergedData() {
      const merged = [];
      if (this.isDKRAS) {
        const dkrasData = this.form.위험성평가표.DKRAS.data;
        for (let i = 0; i < dkrasData.length; i++) {
          merged.push(Object.assign({}, dkrasData[i], { _type: "DKRAS", _idx: i }));
        }
      }
      if (this.isJSA) {
        const jsaData = this.form.위험성평가표.JSA.data;
        for (let i = 0; i < jsaData.length; i++) {
          merged.push(Object.assign({}, jsaData[i], { _type: "JSA", _idx: i }));
        }
      }
      this.form.위험성평가표.data = merged;
    },

    resetForm(key) {
      if (key === "위험성평가표") {
        this.form[key].위험도 = "";
        this.form[key].중요위험 = "";
        this.form[key].data = [];
        this.form[key].DKRAS.data = [];
        this.form[key].DKRAS.위험도 = "";
        this.form[key].DKRAS.중요위험 = "";
        this.form[key].DKRAS.안전보호구 = "";
        this.form[key].DKRAS.정리정돈사항 = "";
        this.form[key].DKRAS.ONEPOINT = "";
        this.form[key].JSA.data = [];
        this.form[key].JSA.위험도 = "";
        this.form[key].JSA.중요위험 = "";
      }
    },
    getRisk(발생빈도, 위험강도) {
      const 위험도 = parseInt(발생빈도) * parseInt(위험강도);

      if (위험도 >= 20) {
        return {
          name: "중요위험(허용불가능)",
          color: "#EA5455",
        };
      }

      if (위험도 >= 10 || 발생빈도 >= 5) {
        return {
          name: "중요위험(허용가능)",
          color: "#FF9F43",
        };
      }

      return {
        name: "일반",
        color: "#28C76F",
      };
    },

    onSelectProcess(raw) {
      console.log("onSelectProcess", raw.소분류);
      this.form.공정분류.대분류 = raw.대분류;
      this.form.공정분류.중분류 = raw.중분류;
      this.form.공정분류.소분류 = raw.소분류;
      this.form.위험성평가정보.공장 = raw.공장명;
      this.form.위험성평가정보.팀 = raw.팀명;

      this.공정분류선택 = true;

      this.form.공정명비활성화여부 = true;
    },

    async syncProcess736Data(postId) {
      try {
        const response = await this.$store.dispatch("board/LOAD_POST", { boardId: 736, postId });
        if (!response) return;
        const body = response.body || (response.post_content && JSON.parse(response.post_content).body);
        if (!body) return;
        if (body.대분류) this.form.공정분류.대분류 = body.대분류;
        if (body.중분류) this.form.공정분류.중분류 = body.중분류;
        if (body.소분류) this.form.공정분류.소분류 = body.소분류;
        if (body.공장명) this.form.위험성평가정보.공장 = body.공장명;
        if (body.팀명) this.form.위험성평가정보.팀 = body.팀명;
      } catch (e) {
        // 736 데이터 조회 실패 시 기존 저장값 유지
      }
    },

    async validate(type) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
        if (!this.$v.form.위험성평가구분.required) return "위험성평가 구분을 반드시 선택해야 합니다";

        if (!this.$v.form.위험성평가정보.평가일자.required) return "위험성평가 정보의 평가일자를 반드시 입력해야 합니다";
        if (!this.$v.form.위험성평가정보.공장.required) return "위험성평가 정보의 공장을 반드시 입력해야 합니다";
        if (!this.$v.form.위험성평가정보.팀.required) return "위험성평가 정보의 팀을 반드시 입력해야 합니다";
        if (!this.$v.form.위험성평가정보.공정.required) return "위험성평가 정보의 공정을 반드시 입력해야 합니다";

        if (!this.공정분류선택) return "공정분류를 반드시 선택해야 합니다";

        if (!this.$v.form.공정분류.구분.required) return "공정분류의 구분을 반드시 입력해야 합니다";
        if (!this.$v.form.공정분류.아차사고.required) return "공정분류의 아차사고를 반드시 입력해야 합니다";

        if (!this.$v.form.작업빈도.일.required && !this.$v.form.작업빈도.주.required && !this.$v.form.작업빈도.월.required && !this.$v.form.작업빈도.분기.required && !this.$v.form.작업빈도.년.required) {
          return "작업빈도 테이블을 반드시 입력해야 합니다";
        }
        if (!this.$v.form.작업빈도.회당작업시간.required) return "작업빈도의 회당작업시간을 반드시 입력해야 합니다";

        if (!this.$v.form.sign.작성자.name.required) return "작성자를 반드시 입력해야 합니다";
        if (!this.$v.form.sign.검토자.name.required) return "검토자를 반드시 입력해야 합니다";

        // if (!this.$v.form.동일직무인원.상주반.required || !this.$v.form.동일직무인원.교대반.required) return "동일직무인원을 반드시 입력해야 합니다";
      }

      // 비즈니스 로직 validation - 기본 validation과 별개로 항상 실행
      if (this.is위험도20) return "중요위험(허용불가능) 위험도가 있습니다. 즉시 개선하십시오.";

      // 중요위험 이상부터(빈도 5점포함)는 해당 항목만 감소대책 담당자 완료일 필수로 입력 (25.04.16)
      // 845, 813, 814 공통조건
      const allValidateData = [];
      if (this.isDKRAS) allValidateData.push.apply(allValidateData, this.form.위험성평가표.DKRAS.data);
      if (this.isJSA) allValidateData.push.apply(allValidateData, this.form.위험성평가표.JSA.data);

      const isMissing = allValidateData.some((item) => {
        // 발생빈도 5이상 또는 위험강도 10이상인 항목만 체크
        if (item.발생빈도 >= 5 || item.위험강도 >= 10) {
          // 해당 항목의 감소대책, 담당자, 완료예정일이 없으면 true
          return !item.감소대책 || !item.담당자 || !item.완료예정일;
        }
        // 중요위험이 아닌 항목은 검사하지 않음
        return false;
      });
      if (isMissing) return "중요위험(허용가능) 위험이 있는 항목은 감소대책, 담당자, 완료일을 입력해주세요.";

      // 위험도가 0인 경우 발생빈도와 위험강도 필수 입력 검증
      const isZeroRiskMissing = allValidateData.some((item) => {
        const 위험도 = Number(item.발생빈도 || 0) * Number(item.위험강도 || 0);
        if (위험도 === 0) {
          // 발생빈도나 위험강도가 입력되지 않았거나 0인 경우
          return !item.발생빈도 || !item.위험강도 || Number(item.발생빈도) === 0 || Number(item.위험강도) === 0;
        }
        return false;
      });
      if (isZeroRiskMissing) return "위험도가 0인 항목이 있습니다. 발생빈도와 위험강도를 반드시 입력해주세요.";

      // 하나의 부모 문서로 여러개의 문서를 등록할 수 없도록 막음
      if (this.parentId > 0) {
        const response = await this.$store.dispatch("approval/LOAD_POST_ALL", {
          boardSlug: `board-${this.boardId}`,
          projectId: this.projectId,
          perPage: 100,
          conditions: [{ key: "post_parent_id", operator: "=", value: this.parentId }],
          isParent: false, // 최신문서만 검색
        });

        const data = response.data;
        if (data && data.length > 0) {
          const posts = data.filter((item) => item.document_status_id !== 1 && item.document_status_id !== 5 && `${item.post_id}` !== `${this.postId}`);
          if (posts.length > 0) {
            return "이미 개정문서가 등록되어 있습니다.";
          }
        }
      }

      // 동일한 공정분류로 결재 (진행, 승인) 문서가 있으면 등록할 수 없도록
      // 공정분류가 이미 사용중일때 저장못함
      if (this.form.공정분류.raw) {
        const 공정분류ID = this.form.공정분류.raw.id;

        const response = await this.$store.dispatch("approval/LOAD_POST_ALL", {
          boardSlug: `board-${this.boardId}`,
          projectId: this.projectId,
          perPage: 100,
          conditions: [{ key: "body.공정분류.raw.id", operator: "=", value: 공정분류ID }],
          isParent: false, // 최신문서만 검색
        });

        const data = response.data;
        if (0 < data.length) {
          const postIdLine = [Number(`${this.postId}`)];
          if (this.parentId > 0) {
            postIdLine.push(Number(`${this.parentId}`));
          }

          /** 요청에 의해 일단 삭제 */
          // 동일한 공정분류로 결재 (등록, 진행, 승인) 문서가 현재문서이거나, 부모 문서가 아닌 경우 확인
          // let returnStr = null;
          // data.map((_item) => {
          //   const postId = _item.post_id;
          //   if (!postIdLine.includes(postId)) {
          //     // registered, ongoing, approved 셋중 하나가 존재하면 저장못하도록 막음
          //     const statusArr = ["registered", "ongoing", "approved"];
          //     if (statusArr.includes(_item.document_status.code)) {
          //       returnStr = "이미 다른 결재문서에서 선택된 공정분류입니다.";
          //     }
          //   }
          // });
          // if (returnStr) return returnStr;
        }
      }

      if ((type === "upload" || type === "create_upload") && this.isRevision) {
        // confirm 처리 후 return
        const confirm = await this.$refs.confirm.open();

        if (confirm && this.popup.approval === "Yes") {
          return {
            success: true,
          };
        }

        return {
          success: false,
        };
      }
    },

    // 문서 우측 상단 버튼들
    // 커스텀 버튼을 넣고 싶은 경우, tab/Index.vue 의 writeApprovalButtonsTemplate 함수를 참고하여 Json 작성
    setApprovalButtons(template) {
      let success = true;
      const allApprovalData = [];
      if (this.isDKRAS) allApprovalData.push.apply(allApprovalData, this.form.위험성평가표.DKRAS.data);
      if (this.isJSA) allApprovalData.push.apply(allApprovalData, this.form.위험성평가표.JSA.data);
      if (this.isRevision) {
        for (let index = 0; index < allApprovalData.length; index++) {
          const row = allApprovalData[index];
          if (row.개선후_위험도 >= 10 || row.개선후_발생빈도 >= 5) {
            success = false;
            break;
          }
        }
      } else {
        for (let index = 0; index < allApprovalData.length; index++) {
          const row = allApprovalData[index];
          if (row.위험도 >= 10 || row.발생빈도 >= 5) {
            success = false;
            break;
          }
        }
      }

      const copysave = JSON.parse(JSON.stringify(template.copysave));
      copysave.shouldShow.freePass = success ? 0 : -1;
      copysave.emits.click = (func) => {
        if (this.is위험도20) {
          this.popup.warning20 = true;
        } else {
          // 평가일자 오늘날짜로 변경
          this.form.위험성평가정보.평가일자 = new Date().format("yyyy-MM-dd");

          // 개정할 경우, 개선 후 데이터를 현재 위험도로 복사 후 개선 후 데이터 삭제
          const revisionDataSets = [];
          if (this.isDKRAS && this.form.위험성평가표.DKRAS.data && this.form.위험성평가표.DKRAS.data.length > 0) {
            revisionDataSets.push(this.form.위험성평가표.DKRAS.data);
          }
          if (this.isJSA && this.form.위험성평가표.JSA.data && this.form.위험성평가표.JSA.data.length > 0) {
            revisionDataSets.push(this.form.위험성평가표.JSA.data);
          }
          for (let di = 0; di < revisionDataSets.length; di++) {
            for (const data of revisionDataSets[di]) {
              data.현재관리상태 = data.개선결과;
              data.발생빈도 = data.개선후_발생빈도;
              data.위험강도 = data.개선후_위험강도;
              data.단위위험 = data.개선후_단위위험;
              data.위험도 = data.개선후_위험도;

              delete data.감소대책;
              delete data.개선후_발생빈도;
              delete data.개선후_위험강도;
              delete data.개선후_단위위험;
              delete data.개선후_위험도;
              delete data.개선결과;
            }
          }

          // 개선내역 초기화
          this.form.개선내역 = [
            {
              위험성평가: { 작업내용: "", 위험요인: "", 개선대책: "", 개선완료일: "" },
              개선사항: {
                개선전: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
                개선후: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
              },
            },
          ];

          this.form.fileList = [];

          func.copysave((result) => {
            if (result && result.postId) {
              const postId = result.postId;
              const route = this.$route;
              route.params.postId = postId;
              const routeData = this.$router.resolve({ name: route.name, params: route.params });
              window.open(routeData.href, "_blank");

              this.$router.go(0);
            }
            return false;
          });
        }
      };

      const 개정이력버튼 = {
        shouldShow: { mode: "u", freePass: 0, permission: "r", onlyWriter: false },
        component: "vs-button",
        props: {
          class: "revision-history-button",
          color: "secondary",
          type: "border",
        },
        content: "개정이력",
        emits: {
          click: (e) => {
            const isEnabled = this.isRevisionHistoryEnabled;

            if (isEnabled) {
              this.showRevisionHistoryPopup(e);
            } else {
              this.$vs.notify({
                title: "알림",
                text: "사업장, 공장, 대분류, 중분류, 소분류를 모두 입력해주세요.",
                color: "warning",
                position: "top-right",
              });
            }
          },
        },
      };

      return [개정이력버튼, copysave, template.resend, template.print, template.delete, template.move, template.save, template.recall];
    },

    showRevisionHistoryPopup() {
      // 이미 팝업이 열려있으면 닫기
      if (this.revisionHistoryPopup.show) {
        this.closeRevisionHistoryPopup();
        return;
      }

      this.loadRevisionHistory();

      // 버튼 요소 찾기
      const button = document.querySelector(".revision-history-button");
      if (!button) return;

      const rect = button.getBoundingClientRect();
      const popupWidth = 300;
      const windowWidth = window.innerWidth;

      // 우측 공간 확인 (버튼 왼쪽 시작점 + 팝업 폭)
      const spaceOnRight = windowWidth - rect.left;

      let left = 0;

      if (spaceOnRight >= popupWidth) {
        // 우측에 공간이 충분하면 버튼 왼쪽과 팝업 왼쪽 정렬
        left = rect.left;
      } else {
        // 우측 공간이 부족하면 버튼 오른쪽 끝과 팝업 오른쪽 끝 정렬
        left = rect.right - popupWidth;
      }

      // 버튼 아래에 표시
      const top = rect.bottom + 8;

      this.revisionHistoryPopup.position.top = top;
      this.revisionHistoryPopup.position.left = left;
      this.revisionHistoryPopup.show = true;
    },

    closeRevisionHistoryPopup() {
      this.revisionHistoryPopup.show = false;
    },

    handleClickOutside(event) {
      if (this.revisionHistoryPopup.show) {
        const popup = this.$refs.revisionHistoryPopup;
        const button = document.querySelector(".revision-history-button");

        if (popup && !popup.contains(event.target) && button && !button.contains(event.target)) {
          this.closeRevisionHistoryPopup();
        }
      }
    },

    async loadRevisionHistory() {
      this.revisionHistoryPopup.loading = true;
      this.revisionHistoryData = [];

      try {
        const projectId = this.projectId;
        const page = 1;
        const perPage = 100;
        const orderTarget = "id";
        const orderDirection = "desc";
        const statusIds = [4];
        const conditions = [];

        // 임시저장 문서는 사용자가 작성한 문서만 조회되도록 해야 한다
        conditions.push(
          { key: "body.stdInfo.field_id", operator: "=", value: this.form.stdInfo.field_id },
          { key: "body.위험성평가정보.공장", operator: "=", value: this.form.위험성평가정보.공장 },
          { key: "body.공정분류.대분류", operator: "=", value: this.form.공정분류.대분류 },
          { key: "body.공정분류.중분류", operator: "=", value: this.form.공정분류.중분류 },
          { key: "body.공정분류.소분류", operator: "=", value: this.form.공정분류.소분류 }
        );

        const listData = await this.$store.dispatch("approval/LOAD_POST_ALL", {
          page,
          perPage,
          projectId,
          orderTarget,
          orderDirection,
          conditions,
          statusIds,
          metaKeys: ["body.stdInfo.writer_name", "body.stdInfo.field_name", "body.위험성평가정보.공장", "body.공정분류.대분류", "body.공정분류.중분류", "body.공정분류.소분류"],
          withMeta: true,
          onlyMeta: true,
          withoutRelation: true,
        });

        // 데이터를 revisionHistoryData로 변환
        if (listData && listData.data && listData.data.length > 0) {
          this.revisionHistoryData = listData.data.map((item, index) => {
            const revNumber = listData.data.length - 1 - index;
            const approvedDate = item.approved_at ? item.approved_at.split(" ")[0] : "";

            // postContents.body.stdInfo.writer_name에서 작성자 이름 가져오기
            let authorName = "기안자";
            if (item.postContents && item.postContents.body && item.postContents.body.stdInfo && item.postContents.body.stdInfo.writer_name) {
              authorName = item.postContents.body.stdInfo.writer_name;
            }

            return {
              revision: `Rev.${revNumber}`,
              author: authorName,
              date: approvedDate,
              postId: item.post_id,
              projectId: item.project_id,
              boardId: item.board_id,
            };
          });
        }
      } catch (error) {
        console.error("개정이력 로드 실패:", error);
      } finally {
        this.revisionHistoryPopup.loading = false;
      }
    },

    onClickRevisionItem(item) {
      const message = `${item.revision} 문서로 이동하시겠습니까?`;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "확인",
        text: message,
        acceptText: "확인",
        cancelText: "취소",
        accept: () => {
          const url = `/project/${item.projectId}/tab/${item.boardId}/write/${item.postId}`;
          this.$router.push(url);
        },
      });
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
    text-align: center;
  }

  th {
    background-color: #f9f9f9;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    font-weight: bold;
    color: #3c3c3c;
  }

  td {
    background-color: #fff;
  }
}

.table-custom ::v-deep {
  .table-custom-body {
    overflow-x: auto;
  }
}

.print-break-page {
  page-break-before: always;
}

.revision-history-popup {
  width: 300px;
  background: white;
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  overflow: hidden;
}

.revision-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
}

.revision-history-title {
  font-size: 16px;
  font-weight: 600;
  color: #3c3c3c;
}

.revision-history-close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;

  &:hover {
    color: #3c3c3c;
  }
}

.revision-history-list {
  max-height: 400px;
  overflow-y: auto;
}

.revision-history-item {
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
}

.revision-history-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.revision-number {
  font-size: 14px;
  font-weight: 600;
  color: #3c3c3c;
  min-width: 50px;
}

.revision-author {
  font-size: 14px;
  color: #666;
  flex: 1;
  text-align: center;
}

.revision-date {
  font-size: 14px;
  color: #999;
  min-width: 80px;
  text-align: right;
}

.revision-history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 12px;
  color: #666;
  font-size: 14px;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f0f0f0;
  border-top-color: #7e72f2;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.revision-history-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}
</style>
